'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getCUInfor = getCUInfor;
var GET_CU_INFOR = 'bp/cu/detail/GET_CU_INFOR';
var GET_CU_INFOR_SUCCESS = 'bp/cu/detail/GET_CU_INFOR_SUCCESS';
var GET_CU_INFOR_FAIL = 'bp/cu/detail/GET_CU_INFOR_FAIL';

var initialState = {
    cuHashId: "",
    infor: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CU_INFOR:
            return _extends({}, state, {
                cuHashId: action.cuHashId,
                infor: {}
            });
        case GET_CU_INFOR_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                infor: action.result.data.data
            });
        default:
            return state;
    }
}

function getCUInfor(cuHashId) {
    return {
        types: [GET_CU_INFOR, GET_CU_INFOR_SUCCESS, GET_CU_INFOR_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/cu_school/info?schoolHashId=' + cuHashId);
            }

            return promise;
        }(),
        cuHashId: cuHashId
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cu/cuInfor.js
// module id = 457
// module chunks = 0